<template>
    <span class="bg-gray-700 text-white uppercase text-1xl flex w-full justify-center text-center p-4">Jackpots</span>
    <div class="sm:mb-4 p-6 text-white bg-gray-900 bg-primary-cta bg-no-repeat items-center justify-center flex transition duration-500 ease-in-out mt-0">

        <span class="text-white uppercase text-1xl flex w-full justify-center text-center">Daily</span>

		<span class="flex w-full justify-center font-bold text-center text-3xl sm:text-5xl text-racing-stars-yellow"><counter ref="dailyJackpot" :startAmount="0" :endAmount="$page.props.racingstars.dailyJackpot / 100" :duration="duration($page.props.racingstars.dailyJackpot / 100)" prefix="&pound;" @finished="restartDaily()" /></span>

        <span class="text-white uppercase text-1xl flex w-full justify-center text-center">Weekly</span>

        <span class="flex w-full justify-center font-bold text-center text-3xl sm:text-5xl text-racing-stars-yellow"><counter ref="weeklyJackpot" :startAmount="0" :endAmount="$page.props.racingstars.weeklyJackpot / 100" :duration="duration($page.props.racingstars.weeklyJackpot / 100)" prefix="&pound;" @finished="restartWeekly()" /></span>
    </div>
</template>

<script>
import { ref } from 'vue'
import Counter from 'vue3-autocounter';

export default {
    components: {
        Counter,
    },
    setup(props) {
        const dailyJackpot = ref(null)

        const weeklyJackpot = ref(null)

        /**
         * Formatter function required to format currencies/prices correctly.
         * 
         * @type {Intl}
         */
        const formatter = new Intl.NumberFormat('en-GB', {
            style: 'currency',
            currency: 'GBP',
        })

        const restartDaily = () => {
            if (dailyJackpot.value) {
                dailyJackpot.value.reset()
                dailyJackpot.value.start()
            }
        }

        const restartWeekly = () => {
            if (weeklyJackpot.value) {
                weeklyJackpot.value.reset()
                weeklyJackpot.value.start()
            }
        }

        const duration = (jackpot) => {
            return (parseInt(jackpot) / 100) * 6
        }

        return {
            formatter,
            dailyJackpot,
            weeklyJackpot,
            restartDaily,
            restartWeekly,
            duration,
        }
    }
}
</script>